module.exports = __webpack_public_path__ + "img/icon-01.7fc1eff2.svg";